import { render, staticRenderFns } from "./p_esg025.vue?vue&type=template&id=0c67decf&scoped=true&"
import script from "./p_esg025.vue?vue&type=script&lang=js&"
export * from "./p_esg025.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c67decf",
  null
  
)

export default component.exports